export const availableServices = [
    {
        type: 'facebook',
        label: 'Facebook',
        url: 'https://www.facebook.com/sharer.php?u=',
    },
    {
        type: 'linkedin',
        label: 'LinkedIn',
        url: 'https://www.linkedin.com/shareArticle?mini=true&url=',
    },
    { type: 'twitter', label: 'Twitter', url: 'https://twitter.com/share?url=' },
    {
        type: 'xing',
        label: 'Xing',
        url: 'https://www.xing.com/social/share/spi?url=',
    },
];
const DEFAULT_WINDOW_POPUP_HEIGHT = 400;
const DEFAULT_WINDOW_POPUP_WIDTH = 500;
export const windowPopupSettings = ({ height = DEFAULT_WINDOW_POPUP_HEIGHT, resizable = 'no', width = DEFAULT_WINDOW_POPUP_WIDTH, } = {}) => {
    const top = (window.screen.height - height) / 4;
    const left = (window.screen.width - width) / 2;
    return [
        `width=${width}`,
        `height=${height}`,
        `resizable=${resizable}`,
        `top=${top}`,
        `left=${left}`,
    ];
};
//# sourceMappingURL=index.js.map